import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/styles/Personalization.scss";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PushPinIcon from "@mui/icons-material/PushPin";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

function Personalization() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <div className="personalization-outer">
      <div className="personalization-grid">
        <div className="personalization-copy" data-aos="fade-up">
          <span className="section-eyebrow">Personalization</span>
          <h2 className="section-title">A Feed Tailored to Your Football Interests</h2>
          <p className="section-description">
            Most football apps send the same alerts to every user. Goal Guru
            is built to do the opposite. Every Smart Alert, favorite league,
            and pinned match you set teaches the platform more about what you
            actually care about — so the notifications you get become more
            relevant over time, not more numerous.
          </p>
          <p className="section-description">
            This is the direction the entire platform is moving in: from
            configurable alerts today, toward fully personalized sports
            intelligence that automatically surfaces the matches and moments
            most relevant to you — without you having to ask.
          </p>
        </div>

        <div className="personalization-cards">
          <div className="pcard" data-aos="fade-up" data-aos-delay="100">
            <div className="pcard-icon">
              <PsychologyIcon />
            </div>
            <h3>Learns Your Preferences</h3>
            <p>
              Your alert history, favorite teams, and tracked leagues all feed
              into how Goal Guru prioritizes what to show you.
            </p>
          </div>
          <div className="pcard" data-aos="fade-up" data-aos-delay="200">
            <div className="pcard-icon">
              <PushPinIcon />
            </div>
            <h3>Prioritizes What Matters</h3>
            <p>
              Favorited matches and high-relevance conditions are surfaced
              first, ahead of generic scores and league-wide noise.
            </p>
          </div>
          <div className="pcard" data-aos="fade-up" data-aos-delay="300">
            <div className="pcard-icon">
              <FilterAltIcon />
            </div>
            <h3>Reduces Information Overload</h3>
            <p>
              Instead of a firehose of stats from every match on the calendar,
              you get a filtered feed built around your own criteria.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Personalization;
